import { useChatbotStore } from '@/stores/chatbot'

/**
 * MYAC-918 — start a new conversation. The one on screen is kept in the
 * person's list (every conversation is); nothing more to say about it
 * (Arslene, 2026-10-12: the mockup's « … est rangée » notice is noise).
 *
 * A plain function, not a composable: the chat interface calls it from hosts
 * (and tests) that have no router.
 */
export async function startNewConversation(): Promise<void> {
  await useChatbotStore().resetSession({ userInitiated: true })
}
